import { PaymentStatus, PaymentStatusLabel, PaymentStatusTone } from '@bariendo/lib/payment-status';
import { CSSProperties, ReactElement } from 'react';
import { STATUS_BADGE_TONES } from '@/theme/colors';

const BADGE_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: 12,
  lineHeight: '16px',
  fontWeight: 500,
  padding: '1px 9px',
  borderRadius: 100,
  whiteSpace: 'nowrap',
};

/** The payment status as a Status badge, one colour per status on every track (BAR-3084). */
export function PaymentStatusBadge({ status }: { status: PaymentStatus }): ReactElement {
  return (
    <span
      data-tone={PaymentStatusTone[status]}
      style={{ ...BADGE_STYLE, ...STATUS_BADGE_TONES[PaymentStatusTone[status]] }}
    >
      {PaymentStatusLabel[status]}
    </span>
  );
}
